import React from "react";
import DatePicker from "react-datepicker";
import { useField, useFormikContext } from "formik";
import "react-datepicker/dist/react-datepicker.css";

export default function CustomDatePicker({
  tip,
  dateFormat = "dd/MM/yyyy",
  testId = "datepicker",
  color = "#407A28",
  showTimeSelect = false,
  timeIntervals = 15,
  wrapperStyle = {},
  label,
  ...other
}) {
  const processedWrapperStyle =
    typeof wrapperStyle === "string" ? {} : wrapperStyle;

  const datePickerViewStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    padding: "8px 15px 12px",
    marginBottom: "10px",
    borderBottom: `1px solid ${color}`,
    borderRadius: "4px 4px 0 0",
    boxSizing: "border-box",
    ...processedWrapperStyle,
  };

  const wrapperLabelStyle = {
    display: "block",
    marginBottom: 0,
  };

  const labelStyle = {
    fontSize: "12px",
    color: color,
    letterSpacing: "0.4px",
  };

  return (
    <>
      <style>
        {`
          .datepicker {
            border: none;
            background-color: #f3f6f9;
            color: #464e5f;
            width: 100%;
            outline: none;
          }

          .react-datepicker__day--keyboard-selected,
          .react-datepicker__month-text--keyboard-selected,
          .react-datepicker__quarter-text--keyboard-selected {
            background-color: ${color};
          }
        `}
      </style>
      <div style={datePickerViewStyle} data-testid={testId}>
        <label style={wrapperLabelStyle}>
          {label && <div style={labelStyle}>{label}</div>}
          <DatePicker
            dateFormat={dateFormat}
            showTimeSelect={showTimeSelect}
            timeIntervals={timeIntervals}
            className="datepicker"
            {...other}
          />
        </label>
      </div>
      {tip && <div>{tip}</div>}
    </>
  );
}

export const MappedDatePicker = ({ ...props }) => {
  const formGroupStyle = { marginBottom: "1.75rem" };

  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);

  function getTip(meta = {}, tip) {
    if (tip) {
      return <span>{tip}</span>;
    }
  }

  return (
    <div style={formGroupStyle}>
      <CustomDatePicker
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
        tip={getTip(meta, props.tip)}
      />
    </div>
  );
};
